import { getFunctions, httpsCallable } from 'firebase/functions'

interface GeminiResponse {
  candidates?: Array<{
    content?: { parts?: Array<{ text?: string; inlineData?: { data: string; mimeType: string } }> }
  }>
}

const fns = getFunctions()

const generateContentCallable = httpsCallable<{ model: string; contents: any[]; config?: any }, GeminiResponse>(fns, 'generateContent')
const ttsCallable = httpsCallable<{ text: string; voiceName?: string }, GeminiResponse>(fns, 'tts')

export async function proxyGenerateContent(model: string, contents: any[], config?: any) {
  try {
    const result = await generateContentCallable({ model, contents, config })
    return result.data
  } catch (err: any) {
    // Preserve FirebaseError shape for caller (code/message/details)
    console.error('[geminiProxy] generateContent failed', err?.code, err?.message, err?.details)
    throw err
  }
}

export async function proxyTTS(text: string, voiceName?: string) {
  try {
    const result = await ttsCallable({ text, voiceName })
    return result.data
  } catch (err: any) {
    console.error('[geminiProxy] tts failed', err?.code, err?.message, err?.details)
    throw err
  }
}
